import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/memberVisitsSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypeFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.memberVisits.filters.membership_types);
  const selectedFilters = useSelector(
    (state) => state.memberVisits.selectedFilters.membership_types
  );

  return (
    <div className="select-box" style={{ width: "200px" }}>
      <p className="offers-title">Membership Type</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        placeholder="Not selected"
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFilter({ key: "membership_types", data }))
        }
      />
    </div>
  );
};

export default MembershipTypeFilter;
